import { tokens, primitives } from '../tokens'

// Paleta legacy de Velora Classic. Se mantienen las claves para no romper los
// componentes que ya las importan; los valores salen del design system de Velora
// (token semántico más cercano al color original, anotado a la derecha).
const { color } = tokens

export default {
  black: color.text.primary, // antes #000000
  blackAlpha80: 'rgba(0, 0, 0, 0.8)',
  blackAlpha50: 'rgba(0, 0, 0, 0.5)',
  blackAlpha40: 'rgba(0, 0, 0, 0.4)',
  blackAlpha41: color.border.strong, // antes #B0B3BB
  blackAlpha30: 'rgba(0, 0, 0, 0.3)',
  blackAlpha20: 'rgba(0, 0, 0, 0.2)',
  blackAlpha10: 'rgba(0, 0, 0, 0.1)',
  white: primitives.white, // antes '#FFFFFF;' (el ';' invalidaba el color fuera de los styled)
  whiteAlpha50: 'rgba(255, 255, 255, 0.5)',
  whiteAlpha24: 'rgba(255, 255, 255, 0.24)',
  whiteAlpha75: 'rgba(255, 255, 255, 0.75)',
  blue: color.brand.primary, // antes #00A0E1 — primario por defecto si el cliente no define el suyo
  blue2: color.brandInteractive.primaryHover, // antes #0076a6
  darkBlue: color.brandInteractive.primaryHover, // antes rgb(0, 112, 157)
  blueAlpha: `${color.brand.primary}aa`, // antes #00A0E1aa
  blueAlpha15: `${color.brand.primary}22`, // antes #00A0E122
  grey: color.text.tertiary, // antes #666
  grey2: color.background.surface, // antes #FAFAFA
  grey3: color.text.tertiary, // antes #7A808D
  grey4: color.text.label, // antes #181A1C
  grey5: color.text.secondary, // antes #494D55
  grey6: color.text.tertiary, // antes #7A808D
  grey7: color.background.light, // antes #F2F2F4
  grey8: color.text.body, // antes #818181
  // rgba de border.strong (#9ca3af); antes rgba(148, 163, 178, x)
  greyAlpha50: 'rgba(156, 163, 175, 0.5)',
  greyAlpha25: 'rgba(156, 163, 175, 0.25)',
  greyAlpha26: color.border.subtle, // antes #E4E6E8
  greyAlpha15: 'rgba(156, 163, 175, 0.15)',
  darkGrey: color.border.default, // antes #C6CED6
  darkGrey2: color.text.tertiary, // antes #637B92
  darkGrey3: color.text.disabled, // antes #94A3B2
  yellow: color.category.desired, // antes #DCCD47
  red: color.error.main, // antes #FB344C
  green: color.success.main, // antes #5DCA62
  orange: color.brand.orange, // antes #E0A93F
  gold: color.warning.bg, // antes #ead1a2

  pageBackground: color.background.surface // antes #FBFBFB
}
